// Quill 2 emits bullets as <ol><li data-list="bullet">, hence the data-list overrides.
const htmlContentClass = [
  'max-w-none overflow-x-hidden break-words text-sm leading-relaxed text-gray-600',
  '[&_p]:my-1.5',
  '[&_a]:break-all [&_a]:text-brand-700 [&_a]:underline',
  '[&_strong]:font-semibold [&_strong]:text-gray-800',
  '[&_ol]:my-2 [&_ol]:list-decimal [&_ol]:pl-5',
  '[&_ul]:my-2 [&_ul]:list-disc [&_ul]:pl-5',
  '[&_li]:my-0.5',
  "[&_li[data-list='bullet']]:list-[disc]",
  "[&_li[data-list='ordered']]:list-[decimal]",
  '[&_img]:h-auto [&_img]:max-w-full',
  '[&_table]:block [&_table]:max-w-full [&_table]:overflow-x-auto',
  '[&_pre]:overflow-x-auto [&_pre]:whitespace-pre-wrap',
].join(' ')

const HtmlContent = ({ html, className = '' }) => {
  if (!html) return null
  return (
    <div
      className={`${htmlContentClass} ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}

export default HtmlContent
